import type { ReactNode } from 'react';

import { cn } from '../utils/cn';

interface IconBadgeProps {
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'accent';
  className?: string;
}

const sizeClasses = {
  sm: 'h-8 w-8 text-base',
  md: 'h-10 w-10 text-lg',
  lg: 'h-12 w-12 text-xl',
};

const variantClasses = {
  default: 'bg-bg-muted text-fg',
  accent: 'bg-accent/10 text-accent',
};

/**
 * Container for an emoji/SVG icon. Used inside Chips, accordion headers,
 * etc. to keep icon sizing consistent.
 */
export const IconBadge = ({
  children,
  size = 'md',
  variant = 'default',
  className,
}: IconBadgeProps) => (
  <span
    aria-hidden
    className={cn(
      'inline-flex shrink-0 items-center justify-center rounded-xl',
      sizeClasses[size],
      variantClasses[variant],
      className,
    )}
  >
    {children}
  </span>
);
